let analyticsInitialized = false;

/** One-time GA + LogRocket init after hydration (StrictMode-safe). */
export function initDeferredAnalytics() {
  if (analyticsInitialized) return;
  analyticsInitialized = true;

  const gaId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;
  if (gaId) {
    void import('react-ga4').then(({ default: ReactGa }) => {
      ReactGa.initialize(gaId);
    });
  }

  const logRocketAppId = import.meta.env.VITE_LOGROCKET_APP_ID;
  if (logRocketAppId) {
    void import('logrocket').then(({ default: LogRocket }) => {
      LogRocket.init(logRocketAppId);
    });
  }
}
